export const ExternalCustomerOrgPartial = `
... on ExternalCustomerOrg {
	contacts {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	customerOrgLastActivity {
		lastActivityAt
		event
	}
	lifeTimeValue {
		value
		currencyCode
	}
	websiteUrl
	industry
	contributors {
		thirdPartyUser {
			id
			name
		}
	}
	country
	accountType
	thirdPartyId
}
`;
